import { translateInComponent, translate } from 'infras/i18n';
import translations from './i18n.json';
import { patch } from 'infras/rest_client';
import {
  DashboardPortalContext,
  setErrorMessage,
} from 'presentations/reducers/DashboardPortal';
import { apiPath } from 'presentations/routes/path';
import { SyntheticEvent, useContext, useEffect, useState } from 'react';
import {
  AssistantUserSettingItem,
  AssistantUserSettingUpdateBody,
} from 'integrations/assistant/presentations/api/schema/assistant_user_setting';

interface Props {
  setting: AssistantUserSettingItem;
}

export const useSummarizeSettingView = (props: Props) => {
  const t = translateInComponent([translations]);
  const { state, dispatch } = useContext(DashboardPortalContext);
  const [isSummaryEventDetail, setIsSummaryEventDetail] = useState<boolean>(
    true,
  );
  const [isSummaryEventCount, setIsSummaryEventCount] = useState<boolean>(true);
  const [isSummaryDuration, setIsSummaryDuration] = useState<boolean>(true);
  const [isSummaryStartTravelTime, setIsSummaryStartTravelTime] = useState<
    boolean
  >(true);
  const [isSummaryTravelType, setIsSummaryTravelType] = useState<boolean>(true);
  const [isSummaryTravelTime, setIsSummaryTravelTime] = useState<boolean>(true);
  const [isSummaryWeather, setIsSummaryWeather] = useState<boolean>(true);
  const [isSummaryTemperature, setIsSummaryTemperature] = useState<boolean>(
    true,
  );
  const [isSummaryReschedule, setIsSummaryReschedule] = useState<boolean>(true);

  useEffect(() => {
    if (!props.setting) return;
    setIsSummaryEventDetail(props.setting.isSummaryEventDetail);
    setIsSummaryEventCount(props.setting.isSummaryEventCount);
    setIsSummaryDuration(props.setting.isSummaryDuration);
    setIsSummaryStartTravelTime(props.setting.isSummaryStartTravelTime);
    setIsSummaryTravelType(props.setting.isSummaryTravelType);
    setIsSummaryTravelTime(props.setting.isSummaryTravelTime);
    setIsSummaryWeather(props.setting.isSummaryWeather);
    setIsSummaryTemperature(props.setting.isSummaryTemperature);
    setIsSummaryReschedule(props.setting.isSummaryReschedule);
  }, [props.setting]);

  const onChangeSetting = async (e: SyntheticEvent<HTMLInputElement>) => {
    if (!props.setting) return;

    const data: AssistantUserSettingUpdateBody = {};

    const { name } = e.currentTarget;
    switch (name) {
      case 'isSummaryEventDetail':
        setIsSummaryEventDetail(!isSummaryEventDetail);
        data.isSummaryEventDetail = !isSummaryEventDetail;
        break;
      case 'isSummaryEventCount':
        setIsSummaryEventCount(!isSummaryEventCount);
        data.isSummaryEventCount = !isSummaryEventCount;
        break;
      case 'isSummaryDuration':
        setIsSummaryDuration(!isSummaryDuration);
        data.isSummaryDuration = !isSummaryDuration;
        break;
      case 'isSummaryStartTravelTime':
        setIsSummaryStartTravelTime(!isSummaryStartTravelTime);
        data.isSummaryStartTravelTime = !isSummaryStartTravelTime;
        break;
      case 'isSummaryTravelType':
        setIsSummaryTravelType(!isSummaryTravelType);
        data.isSummaryTravelType = !isSummaryTravelType;
        break;
      case 'isSummaryTravelTime':
        setIsSummaryTravelTime(!isSummaryTravelTime);
        data.isSummaryTravelTime = !isSummaryTravelTime;
        break;
      case 'isSummaryWeather':
        setIsSummaryWeather(!isSummaryWeather);
        data.isSummaryWeather = !isSummaryWeather;
        break;
      case 'isSummaryTemperature':
        setIsSummaryTemperature(!isSummaryTemperature);
        data.isSummaryTemperature = !isSummaryTemperature;
        break;
      case 'isSummaryReschedule':
        setIsSummaryReschedule(!isSummaryReschedule);
        data.isSummaryReschedule = !isSummaryReschedule;
        break;
      default:
        break;
    }

    const result = await patch(
      apiPath(`/v1/integrations/assistant/user/settings/update`),
      {
        data,
      },
    );
    if (!result.isSuccess) {
      dispatch(setErrorMessage(t('Update error')));
      return;
    }
  };

  return {
    state: {
      isSummaryEventDetail,
      isSummaryEventCount,
      isSummaryDuration,
      isSummaryStartTravelTime,
      isSummaryTravelType,
      isSummaryTravelTime,
      isSummaryWeather,
      isSummaryTemperature,
      isSummaryReschedule,
    },
    actions: {
      onChangeSetting,
    },
  };
};
